/*doc
---
title: Currently Reading
name: currently_reading
category: React
---

Displays all the books on a user's currently reading shelf. Attaches update
reading progress components to each book. If no books are passed in, displays a
book search instead.

This component is used on the home page.
*/
import { map, isEmpty, merge } from "lodash";
import Reflux from "reflux";
import { PropTypes } from "react";
import { hasProgress, truncateBookTitle } from "../../modules/reading_session_helper";
import classNames from "classnames";
import GrComponentFactory from "../gr_component_factory";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import { getImages } from "../../modules/shared/image_registry";
//COMPONENTS
import AddBookSearch from "./add_book_search";
import Book from "../book";
import DotSeparatedElements from "../dot_separated_elements";
import GeneralStatusUpdateButton from "../home_page/general_status_update_button";
import ReadingNotesLink from "../reading_notes/reading_notes_link";
import ReadingProgressBar from "../reading_sessions/reading_progress_bar";
import UpdateReadingProgress from "../update_reading_progress";
import Spinner from "../spinner";

// ACTIONS
import ReadingSessionActions from "../../react_actions/reading_session_actions";
import ShelvingsActions from "../../react_actions/shelvings_actions";
// STORE
import ReadingSessionStore from "../../react_stores/reading_session_store";
// CONSTANTS
import { DEFAULT_SHELVES } from "../../modules/default_shelves";
import { BOOK_ORIGINS } from "../../modules/book_origins";

const linkClassNames = "gr-hyperlink";

export default GrComponentFactory.createClass({
  displayName: "CurrentlyReading",

  mixins: [Reflux.connect(ReadingSessionStore, "readingSessionStore")],

  propTypes: {
    search: PropTypes.shape({
      searchPath: PropTypes.string.isRequired,
      autocompleteUrl: PropTypes.string.isRequired,
    }).isRequired,
    recommendationUrl: PropTypes.string.isRequired,
    askYourFriendsUrl: PropTypes.string.isRequired,
    viewAllCurrentlyReadingUrl: PropTypes.string.isRequired,
    MAX_BODY_LENGTH: PropTypes.number.isRequired,
  },

  getInitialState() {
    return {
      showSearchForm: false,
    };
  },

  renderGeneralUpdateButton() {
    return <GeneralStatusUpdateButton characterLimit={this.props.MAX_BODY_LENGTH} />;
  },

  renderDiscoveryLinks() {
    const links = [
      <a href={this.props.recommendationUrl} className={linkClassNames}>
        Recommendations
      </a>,
      this.renderGeneralUpdateButton(),
    ];
    return (
      <div className="currentlyReadingShelf__discoveryLinks">
        <DotSeparatedElements elements={links} />
      </div>
    );
  },

  shelveAsCurrentlyReading(book) {
    this.setState({ loading: true });
    ShelvingsActions.shelveBook(book.bookId,
                                DEFAULT_SHELVES.CURRENTLY_READING,
                                BOOK_ORIGINS.CURRENTLY_READING_WIDGET);
  },

  showSearchForm() {
    this.setState({ showSearchForm: true });
  },

  renderSparseState() {
    const shelfClassNames =
      classNames("gr-mediaFlexbox",
                 "gr-mediaFlexbox--alignItemsCenter",
                 { "currentlyReadingShelf__empty--loading" : this.state.loading });
    return (
      <div>
        <div className={shelfClassNames}>
          <img className="gr-mediaFlexbox__media" alt="" src={getImages().currentlyReadingSparseStateIcon}/>
          <div className="gr-mediaFlexbox__desc">
            What are you reading?
          </div>
        </div>
      </div>
    );
  },

  renderProgressBar(session) {
    if (hasProgress(session)) {
      return <a className="currentlyReadingShelf__progressBar
                           gr-hyperlink
                           gr-hyperlink--naked"
                href={session.userStatusUrl}>
              <ReadingProgressBar {...session} />
             </a>;
    } else {
      return null;
    }
  },

  renderUpdateButton(session, book, storeState){
    if(session.hideUpdateButton === true) {
      return null;
    } else {
      return <div aria-live="polite">
          {storeState.sessionBeingUpdatedId === session.sessionId ?
              <UpdateReadingProgress
                  existingReadingSession={session}
                  book={book}
                  MAX_BODY_LENGTH={this.props.MAX_BODY_LENGTH}/> :
              <button className="gr-button gr-button--quiet u-marginTopTiny gr-button--small"
                    onClick={() => {
                      ReadingSessionActions.openUpdateProgressForm(session.sessionId);
                    }}>
                Update progress
              </button>
          }
      </div>;
    }
  },

  renderBooks() {
    const storeState = this.state.readingSessionStore;
    if(this.hasReadingSessions()) {
      return (
        <ReactCSSTransitionGroup transitionName="currentlyReadingShelf__item"
                                 transitionEnterTimeout={500}
                                 transitionLeaveTimeout={300}>
          { map(storeState.readingSessions, (session) => {
            const book = merge({}, session.book, {
              title: truncateBookTitle(session.book.title, 40),
            });
            return(
              <Book {...book}
                className="u-marginBottomSmall"
                key={book.bookId}
                mediaBoxModifier="clearfixOverflow">
                {this.renderReadingNotesLink(session.readingNotesCountText,
                                             session.readingNotesUrl,
                                             session.hasSharedContent)}
                {this.renderProgressBar(session)}
                {this.renderUpdateButton(session, book, storeState)}
              </Book>
            );
          }) }
        </ReactCSSTransitionGroup>
      );
    } else {
      return this.renderSparseState();
    }
  },

  renderReadingNotesLink(countText, linkUrl, hasSharedContent) {
    if (isEmpty(countText) || isEmpty(linkUrl)) {
      return null;
    }
    else {
      return <ReadingNotesLink className="u-paddingTopTiny"
                               countTextClassName="u-fontSizeSmall"
                               hasSharedContent={hasSharedContent}
                               readingNotesCountText={countText}
                               readingNotesUrl={linkUrl}/>;
    }
  },

  onAddBookSearchDismiss() {
    this.setState({ showSearchForm: false });
  },

  renderBookSearch() {
    if (!this.hasReadingSessions() || this.state.showSearchForm) {
      return <AddBookSearch bemModifiers="currentlyReading"
                            search={this.props.search}
                            onDismiss={this.onAddBookSearchDismiss}
                            onChooseResult={this.shelveAsCurrentlyReading}/>;
    } else {
      return null;
    }
  },

  loadAll() {
    ReadingSessionActions.loadAllReadingSessions();
  },

  hasMoreSessions() {
    const storeState = this.state.readingSessionStore;
    return storeState.readingSessions.length !== storeState.allReadingSessionsCount;
  },

  viewMoreLink() {
    const storeState = this.state.readingSessionStore;
    if (storeState.loadMoreInProgress) {
      return <Spinner/>;
    } else if (this.hasMoreSessions()) {
      return <button className="gr-buttonAsLink" onClick={this.loadAll}>
        See more
      </button>;
    } else {
      return <a href={this.props.viewAllCurrentlyReadingUrl}>
        View all books
      </a>;
    }
  },

  renderFooterLinks() {
    const links = [
      this.viewMoreLink(),
      // Firefox will persist the 'disabled' state of buttons upon refresh. A
      // workaround is to use an input with 'autocomplete=off' instead of a
      // button. See https://bugzilla.mozilla.org/show_bug.cgi?id=654072
      <input className="gr-buttonAsLink currentlyReadingShelf__addBook"
             value="Add a book"
             onClick={this.showSearchForm}
             type="button"
             disabled={this.state.showSearchForm}
             autoComplete="off" />,
      this.renderGeneralUpdateButton(),
    ];
    return (
      <DotSeparatedElements elements={links} />
    );
  },

  renderFooter() {
    if(this.hasReadingSessions()) {
      return this.renderFooterLinks();
    } else {
      return this.renderDiscoveryLinks();
    }
  },

  hasReadingSessions() {
    return !isEmpty(this.state.readingSessionStore.readingSessions);
  },

  render() {
    return <div>
        <section className="currentlyReadingShelf">
          <h3 className="gr-h3 gr-h3--noTopMargin">Currently Reading</h3>
          {this.renderBooks()}
        </section>
        <footer>
          <div className="u-marginTopXSmall">
            { this.renderBookSearch() }
          </div>
          { this.renderFooter()}
        </footer>
      </div>;
  },
});
